// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__18WTP","productName":"Table_productName__h9pUz"};